import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimeRangeZoneLabelComponent } from './date-time-range-zone-label.component';

@NgModule({
  declarations: [DateTimeRangeZoneLabelComponent],
  exports: [DateTimeRangeZoneLabelComponent],
  imports: [CommonModule],
})
export class DateTimeRangeZoneLabelModule {}
